var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column v-center h-center column"},[_c('h4',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"apexChart"},[_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.chartSeries},on:{"dataPointSelection":_vm.handleChartClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }